import { render, staticRenderFns } from "./IdlePage.vue?vue&type=template&id=6171792c&scoped=true"
import script from "./IdlePage.vue?vue&type=script&lang=js"
export * from "./IdlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171792c",
  null
  
)

export default component.exports